/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-suprimmer': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M15.75 3.38v.74a.38.38 0 01-.37.38H2.63a.38.38 0 01-.38-.38v-.74A1.88 1.88 0 014.13 1.5h2l.25-.5a1.86 1.86 0 011.67-1H10a1.88 1.88 0 011.68 1l.23.46h2a1.88 1.88 0 011.84 1.92zM15 5.62v9.76A2.63 2.63 0 0112.38 18H5.63A2.63 2.63 0 013 15.38V5.62a.38.38 0 01.38-.37h11.25a.38.38 0 01.37.37zm-9 .76a.38.38 0 10-.75 0v9a.38.38 0 00.75 0zm2.25 0a.38.38 0 10-.75 0v9a.38.38 0 00.75 0zm2.25 0a.38.38 0 10-.75 0v9a.38.38 0 00.75 0zm2.25 0a.38.38 0 10-.75 0v9a.38.38 0 00.75 0z"/>'
  }
})
